import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import '../../../../src/Components/css/Designprocess.css'

export default class Localshop extends Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        
        return (
            <div className="row" id="body">
                    
                <div className="col-12 mx-0 col-lg-10" id="content">

                <div className="row pt-4" id="ux_design">
                    <div className="col-12 px-0" id="ow">
                      <p className="h4">Overview</p>
                      <p className="pt-1">
                      Local shop is an eCommerce site. It’s not like other big brands like amazon, flip kart. This site only contains local retailers’ products. People only can purchase to their local area shops. Now this lockdown time people can’t go outside to purchase So, this site will help them to purchase and also local retailers can easily sell their products easily. The ultimate goal of this website is connect the customers and retailers.
                      </p>
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <div className="row mx-0" id="po">
                        <div className="col-sm-4 text-center">
                          <p className="h5">Business type</p>
                          <p>B2B2C</p>
                        </div>
                        <div className="col-sm-4 text-center">
                          <p className="h5">Project duration</p>
                          <p>2 months</p>
                        </div>
                        <div className="col-sm-4 text-center">
                          <p className="h5">My role</p>
                          <p>Ui/Ux and Developer</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <p className="h4">Problem Statement</p>
                        <p className="pt-1">
                        <span className="bullet">Most of the people like online purchase rather than offline purchase<br></br></span>
                        <span className="bullet">There is no possible way to create a website to each and every retailer shop and maintenance is also hard to handle<br></br></span>
                        <span className="bullet">There is no guarantee that every product we order online will have a good quality</span>
                        </p>
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <p className="h4">Project Goal</p>
                        <p className="pt-1">
                        <span className="bullet">Create a GUI based dashboard for retailer shop owners to create, edit, delete their products<br></br></span>
                        <span className="bullet">People can search their nearest shops and order whatever they want<br></br></span>
                        <span className="bullet">Provide online payment service<br></br></span>
                        <span className="bullet">Sent order details through SMS</span>
                        </p>
                    </div>
                    <div className="col-12 px-0 pt-4" id="ds">
                    <p className="h4">Design Process</p>
                      <div className="process">
                      <div>DISCOVER</div>
                      <div>DEFINE</div>
                      <div>IDEATE</div>
                      <div>DESIGN</div>
                      <div>TEST</div>
                      </div>
                    </div>
  
                </div>

                <div className="row pt-4" id="ui_design">
                    <div className="col-12 px-0">
                      <img width="100%" id="dy" src={require('../../../Images/Case_studies/Ls/Design_Strategy.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="cs" src={require('../../../Images/Case_studies/Ls/Compatitive_Analysis.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="uh" src={require('../../../Images/Case_studies/Ls/Qualitative_Research.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" src={require('../../../Images/Case_studies/Ls/Quantitative_Research.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="ua" src={require('../../../Images/Case_studies/Ls/User_Persona.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="ep" src={require('../../../Images/Case_studies/Ls/Empathy_Map.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="cg" src={require('../../../Images/Case_studies/Ls/Card_Sorting.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="uw" src={require('../../../Images/Case_studies/Ls/User_Flow.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="sp" src={require('../../../Images/Case_studies/Ls/Site_Map.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="we" src={require('../../../Images/Case_studies/Ls/Wire_Frame.png')} alt="Case_studies_1" />
                    </div>
                </div>
                
                <div className="row pt-4" id="development">
            
                </div>

            </div>
                    
            <div className="col-lg-2 d-none d-lg-block px-4 pt-4 h-25 sticky-top" id="sidebar" style={{top: "56px"}}>

              <p className="h4">CONTENT</p>
                <p>
                  <AnchorLink href="#ow" className="bullet">Overview</AnchorLink>
                  <br />
                  <AnchorLink href="#po" className="bullet">Project info</AnchorLink>
                  <br />
                  <AnchorLink href="#ds" className="bullet">Design process</AnchorLink>
                  <br />
                  <AnchorLink href="#dy" className="bullet">Design strategy</AnchorLink>
                  <br />
                  <AnchorLink href="#cs" className="bullet">Compatitors</AnchorLink>
                  <br />
                  <AnchorLink href="#uh" className="bullet">User research</AnchorLink>
                  <br />
                  <AnchorLink href="#ua" className="bullet">User persona</AnchorLink>
                  <br />
                  <AnchorLink href="#ep" className="bullet">Empathy map</AnchorLink>
                  <br />
                  <AnchorLink href="#cg" className="bullet">Card sorting</AnchorLink>
                  <br />
                  <AnchorLink href="#uw" className="bullet">User flow</AnchorLink>
                  <br />
                  <AnchorLink href="#sp" className="bullet">Site map</AnchorLink>
                  <br />
                  <AnchorLink href="#we" className="bullet">Wire frame</AnchorLink>
                </p>

                <div className="row pt-4 px-3">
                <p className="h4">TOOLS</p>

                  <div className="col-12 px-2">
                    <div className="row">
                          <img width="25%" className="tools" src={require('../../../Images/Tools/xd.png')} alt="Case_studies_1" />
                          <img width="25%" className="tools" src={require('../../../Images/Tools/ps.png')} alt="Case_studies_1" />
                    </div>
                  </div>
                
                </div>

                </div>
                
                  
            </div>
    )
}
}